import { render, staticRenderFns } from "./explain-results-legend.component.vue?vue&type=template&id=93e8b006"
import script from "./explain-results-legend.component.vue?vue&type=script&lang=ts"
export * from "./explain-results-legend.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports